"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselItem = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var CarouselItem_module_scss_1 = __importDefault(require("./CarouselItem.module.scss"));
/**
 * Renders an individual item within a carousel.
 * @param {ReactElement} item - The JSX element representing the item to render.
 * @param {number} index - The index of the item within the carousel.
 * @param {number} itemsCount - The total number of items in the carousel.
 * @param {number} itemNumber - The number representing the position of the item within the carousel (1-indexed).
 * @returns {ReactElement} JSX element representing the carousel item.
 */
var CarouselItem = function (_a) {
    var item = _a.item, index = _a.index, itemsCount = _a.itemsCount, itemNumber = _a.itemNumber;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(CarouselItem_module_scss_1.default.carousel__item), "aria-roledescription": "slide", "aria-label": "".concat(itemNumber, " of ").concat(itemsCount), "data-index": index, role: "listitem", "data-testid": "item-".concat(itemNumber) }, item));
};
exports.CarouselItem = CarouselItem;
//# sourceMappingURL=CarouselItem.js.map